import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * Long property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.Long)
export class LongPropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<LongPropertyDefinition>, "name">) {
        super(name, DataType.Long);
        Object.assign(this, init);
    }
}
